import type { OnboardingBrowserRuntime } from '../common/services/onboarding-browser-runtime';

/** Design FTO 首页首次引导依赖的浏览器运行时能力。 */
export interface DesignFtoOnboardingRuntime extends OnboardingBrowserRuntime {
    /** 获取当前登录账号 ID；账号不存在时返回空字符串。 */
    getIdentityId(): Promise<string>;
    /** 判断当前用户是否已经登录。 */
    isUserLogin(): Promise<boolean>;
}

/** Design FTO 首页首次引导 runtime 的容器标识。 */
export const DesignFtoOnboardingRuntime = Symbol('DesignFtoOnboardingRuntime');
